import React, { useState } from "react";
import { toast } from "react-hot-toast";

function Appsettings() {
  const [selectedCard, setSelectedCard] = useState(null);
  const [isToggleOn, setIsToggleOn] = useState(false);

  const handleOpenPopup = (index) => {
    setSelectedCard(index);
  };

  const handleClosePopup = () => {
    setSelectedCard(null);
  };

  const handleToggleClick = () => {
    setIsToggleOn((prev) => !prev);
    toast(isToggleOn ? "Bakım modu kapatıldı!" : "Bakım modu açıldı!", {
      icon: isToggleOn ? "❌" : "✅",
    });
  };

  return (
    <div className="bg-sky-100 min-h-screen p-6 rounded shadow" style={{
        marginBottom:20 
    }}>
      {/* Header */}
      <header>
  <h1 className="text-3xl font-bold">Uygulama ayarları</h1>
  <hr className="mt-4 border-gray-400 rounded" />
</header>

      {/* Content */}
      <main className="p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {Array.from({ length: 12 }).map((_, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded shadow hover:shadow-lg transition cursor-pointer"
            onClick={() => handleOpenPopup(index)}
          >
            <h2 className="text-xl font-semibold text-gray-800">Ayar {index + 1}</h2>
            <p className="text-sm text-gray-600 mt-2">
              Bu, Ayar {index + 1} için bir açıklama.
            </p>
          </div>
        ))}
      </main>

      {/* Toggle Button */}
      <div className="flex justify-center mt-6">
        <div className="flex items-center gap-4">
          <span className="text-lg font-semibold text-gray-700">
            Bakım Modu: {isToggleOn ? "Açık" : "Kapalı"}
          </span>
          <div
            className={`relative w-16 h-8 rounded-full flex items-center cursor-pointer transition-colors ${
              isToggleOn ? "bg-green-500" : "bg-gray-400"
            }`}
            onClick={handleToggleClick}
          >
            <div
              className={`absolute w-6 h-6 bg-white rounded-full shadow transform transition-transform ${
                isToggleOn ? "translate-x-8" : "translate-x-1"
              }`}
            ></div>
          </div>
        </div>
        <div className="flex items-center gap-4 pl-4">
          <span className="text-lg font-semibold text-gray-700">
            Bakım Modu: {isToggleOn ? "Açık" : "Kapalı"}
          </span>
          <div
            className={`relative w-16 h-8 rounded-full flex items-center cursor-pointer transition-colors ${
              isToggleOn ? "bg-green-500" : "bg-gray-400"
            }`}
            onClick={handleToggleClick}
          >
            <div
              className={`absolute w-6 h-6 bg-white rounded-full shadow transform transition-transform ${
                isToggleOn ? "translate-x-8" : "translate-x-1"
              }`}
            ></div>
          </div>
        </div>
        <div className="flex items-center gap-4 pl-4">
          <span className="text-lg font-semibold text-gray-700">
            Bakım Modu: {isToggleOn ? "Açık" : "Kapalı"}
          </span>
          <div
            className={`relative w-16 h-8 rounded-full flex items-center cursor-pointer transition-colors ${
              isToggleOn ? "bg-green-500" : "bg-gray-400"
            }`}
            onClick={handleToggleClick}
          >
            <div
              className={`absolute w-6 h-6 bg-white rounded-full shadow transform transition-transform ${
                isToggleOn ? "translate-x-8" : "translate-x-1"
              }`}
            ></div>
          </div>
        </div>
      </div>

      {/* Popup */}
      {selectedCard !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded shadow-lg w-3/4 max-w-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Ayar {selectedCard + 1}
            </h2>
            <p className="text-gray-600">
              Ayar {selectedCard + 1} ile ilgili daha fazla bilgi burada yer alacak.
            </p>
            <button
              className="mt-6 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition"
              onClick={handleClosePopup}
            >
              Kapat
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Appsettings;
